<template>
	<div class="flex-1 flex flex-col">
		<div class="flex-1" v-if="Object.keys(order).length">
			<div class="flex items-center justify-between pb-4 mb-4 ">
				<div class="py-2">
					<h2>Forecast Order</h2>
					<h1 class="text-gray-700 text-2xl sm:text-5xl leading-none">
						{{ order.order_details.reference_id }}
					</h1>
					<h2 class="text-gray-700 text-base sm:text-lg leading-none">
						{{ order.order_details.orderDateTime }}
						<label class="flex items-center space-x-2">
							<input type="checkbox" id="vat" class="form-checkbox h-4 w-4 text-gray-400" v-model="vat">
							<span>inc. VAT</span>
						</label>
					</h2>
				</div>
				<div class="text-right">
					<h2 class="text-gray-700 text-2xl sm:text-5xl leading-none">
						{{ ((order.order_total / 100) * vatAmount) | toCurrency }}
					</h2>
				</div>
			</div>
			<div class="bg-gray-50 p-2 mt-2 border border-b-2" v-for="(job, jobName) in order.jobs">
				<div class="flex items-center justify-between text-lg font-bold mb-2" @click="toggleShow(jobName)">
					<div class="w-48 flex-shrink-0">{{ jobName }}</div>
					<div class="w-48 flex-shrink-0 text-right">{{ ((job.total/100) * vatAmount) | toCurrency }}</div>
				</div>
				<div class=" divide-y" v-if="show.includes(jobName)">
					<div v-for="(details, section) in job.categories">
						<div class="flex items-center justify-between py-1 pl-2">
							<div class="w-48 flex-shrink-0 font-bold" @click="toggleSectionShow(jobName+'-'+sectionName[section])">{{ sectionName[section] }}</div>
							<div class="w-32 flex-shrink-0 text-right">{{ ((details['total']/100) * vatAmount) | toCurrency }}</div>
						</div>
						<div class="pl-4 divide-y" v-if="sectionShow.includes(jobName+'-'+sectionName[section])">
							<div class="flex items-start space-x-6 py-1" v-for="(product, prodName) in details.products">
								<div class="w-72" @click="toggleOrderShow(jobName+'-'+sectionName[section]+'-'+prodName)">{{ prodName }} <span class="text-gray-50">{{product.product_id}}</span></div>
								<div class="flex-1 flex flex-wrap bg-gray-50">
									<div class="text-center text-sm border bg-white m-1 p-1 print:hidden" v-for="order in product.orders" >
										<!-- v-if="orderShow.includes(jobName+'-'+sectionName[section]+'-'+prodName)" -->
										{{ order.section+' '+order.sectionName }}<br/>
										{{ order.qty }}
									</div>									
								</div>
								<div class="w-20 flex-shrink-0 text-center text-sm">
									Total<br/> {{ product.qty }}
								</div>
								<div class="w-20 flex-shrink-0 text-right">{{ ((product.total/100) * vatAmount) | toCurrency }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import {formatDistance, parseISO} from 'date-fns';
export default {
	name: 'ForecastOrderDetail',
	data () {
		return {
			order: {},
			sectionName: {
				first_fix: 'First Fix',
				wire: 'Wire',
				reticulation: 'Reticulation',
				final_fix: 'Final Fix',
				final_fix_gen: 'Final Fix General',
				carport: 'Carports',
				common: 'Common',
				reticulation_general: 'Reticulation General',
				special_area: 'Special Areas',
				tools: 'Tools',
				NA: 'Various',
			},
			displayProducts: {},
			sectionNames: {},
			unitProductBreakDown: [],
			units: {},
			show: [],
			sectionShow: [],
			orderShow: [],
			vat: true,
		}
	},
	computed: {
		vatAmount: function(){
			return this.vat ? 1.15 : 1;
		},
	},
	methods: {
		toggleShow: function(section){
			let itemIndex = this.show.indexOf(section);
			if(itemIndex == -1){
				this.show.push(section);
				return;
			}
			this.show.splice(itemIndex,1);
		},
		toggleSectionShow: function(jobSection){
			let itemIndex = this.sectionShow.indexOf(jobSection);
			if(itemIndex == -1){
				this.sectionShow.push(jobSection);
				return;
			}
			this.sectionShow.splice(itemIndex,1);
		},
		toggleOrderShow: function(jobSectionProduct){
			let itemIndex = this.orderShow.indexOf(jobSectionProduct);
			if(itemIndex == -1){
				this.orderShow.push(jobSectionProduct);
				return;
			}
			this.orderShow.splice(itemIndex,1);
		},
		daysFrom: function(dateString){
			return formatDistance(parseISO(dateString, 'yyyy-MM-dd HH:mm:ss', new Date()), new Date(), { addSuffix: true });
		},
		categoryByKey: function(key){
			let cat = this.$store.getters.getProductCategoryNameByKey(key);
			return cat ? cat : key.charAt(0).toUpperCase() + key.slice(1);
		},
		reload: function () {
			// console.log('here');
			this.$http.get(`/forecast/breakdown/${this.$route.params.forecastid}`)
				.then(response => {
                    // console.log(response.data)
                    let order = {
                    	order_details: response.data.details,
                    	order_total: response.data.total,
                    	jobs: response.data.jobs,
                    }
                    this.order = Object.assign({}, this.order, order);
                    this.show = Object.keys(this.order.jobs);
				})
				.catch(err => {
					this.error = err
				})
		}
	},
	components: {
	},
	created: function () {
		this.$store.commit('setJobName', null)
		// console.log('here11');
		this.reload()
	}
}
</script>
